import React from 'react';
import { Box, Grid } from '@storyofams/react-ui';
import { withStory, WithStoryProps } from '@storyofams/storyblok-toolkit';

import { GetStaticProps, NextPage } from 'next';

import SbEditable from 'storyblok-react';
import { Container, Seo, Heading, Card, Text } from '~components';
import { enhancedStaticProps, withLayout } from '~lib';
import { CallToAction } from '~components/common/CallToAction';
import { IntegrationpageItems } from '~lib/storyblok/sdk';

interface IntegrationsOverviewProps extends WithStoryProps {
  integrations: IntegrationpageItems;
}
const IntegrationsOverview: NextPage<IntegrationsOverviewProps> = ({
  story,
  integrations,
}) => {
  return (
    <>
      <Seo story={story} />

      <Container mb={5}>
        <SbEditable content={story?.content}>
          <Box>
            <Heading variant="h2" as="h1" mb={2}>
              {story?.content?.title}
            </Heading>
            <Text variant="m" mb={4}>
              {story?.content?.description}
            </Text>
          </Box>
        </SbEditable>

        <Box>
          <Grid
            rowSize={[1, 2, 2]}
            columnGap={3}
            rowGap={3}
            maxWidth="764px"
            mb={3}
          >
            {integrations?.items?.map(({ content, slug }) => {
              return (
                <Box>
                  <Card
                    title={content?.title}
                    bg={content?.bg}
                    description={content?.shortDescription}
                    button="Learn more"
                    link={`/integrations/${slug}`}
                  />
                </Box>
              );
            })}
          </Grid>
          <SbEditable content={story?.content}>
            <CallToAction {...story?.content?.call_to_action[0]} />
          </SbEditable>
        </Box>
      </Container>
    </>
  );
};

export default withLayout(withStory(IntegrationsOverview));

export const getStaticProps: GetStaticProps<IntegrationsOverviewProps> =
  enhancedStaticProps(async ({ sdk }) => {
    let story = null;
    let integrations = null;
    let notFound = false;

    try {
      story = (await sdk.integrationsOverview({ slug: 'integrations/' }))
        .IntegrationsoverviewItem;
    } catch (e) {
      notFound = true;
    }

    try {
      integrations = (await sdk.integrations()).IntegrationpageItems;
    } catch (e) {
      console.log(e);
    }

    return {
      props: {
        story,
        integrations,
      },
      notFound: notFound || !story,
      revalidate: 60,
    };
  });
